<div class="fip-dialog-success-body">
  @if (description) {
    <div class="bodylarge p-4">{{ description }}</div>
  }
</div>
